// extracted by mini-css-extract-plugin
export default {"btnTopo":"SolicitacaoDeColeta_btnTopo__2bJBU","content":"SolicitacaoDeColeta_content__SgyJ5","th_tr_Responsive":"SolicitacaoDeColeta_th_tr_Responsive__Y4l0E"};